import React, { useState, useEffect } from 'react';
import {
  View,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Alert,
  Image
} from 'react-native';
import { useTheme, getColor, spacing, getBorderRadius } from '../../theme/useTheme';
import { H1, Body1, ButtonText } from '../../components/common/TextStyles';
import { useAdmin } from '../contexts/AdminContext';

const AdminLoginScreen = ({ navigation }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, error: authError, clearError, admin, isAuthenticated } = useAdmin();

  useEffect(() => {
    if (authError) {
      Alert.alert('Error', authError);
      clearError();
    }
  }, [authError, clearError]);

  useEffect(() => {
    console.log('AdminLoginScreen: isAuthenticated changed:', isAuthenticated);
    if (isAuthenticated) {
      navigation.replace('AdminPanel');
    }
  }, [isAuthenticated, navigation]);

  const handleLogin = async () => {
    if (!email || !password) {
      Alert.alert('Error', 'Please enter all fields');
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      navigation.replace('AdminPanel');
    } catch (error) {
      // Error is handled by the context and displayed via useEffect
    } finally {
      setLoading(false);
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Image
          source={require('../../assets/images/youth-connect.png')}
          style={styles.logo}
          resizeMode="contain"
        />

        <H1 style={styles.title}>Admin Login</H1>

        <Body1 style={styles.subtitle}>
          Sign in to manage Youth Connect
        </Body1>

        <View style={styles.form}>
          <TextInput
            style={styles.input}
            placeholder="Email"
            placeholderTextColor={getColor('text.secondary')}
            value={email}
            onChangeText={setEmail}
            autoCapitalize="none"
            keyboardType="email-address"
          />

          <TextInput
            style={styles.input}
            placeholder="Password"
            placeholderTextColor={getColor('text.secondary')}
            value={password}
            onChangeText={setPassword}
            secureTextEntry
          />

          <TouchableOpacity
            style={[
              styles.button,
              loading && styles.buttonDisabled
            ]}
            onPress={handleLogin}
            disabled={loading}
          >
            <ButtonText style={styles.buttonText}>
              {loading ? 'Signing in...' : 'Sign In'}
            </ButtonText>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: getColor('background.default'),
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing('lg'),
  },
  logo: {
    width: 150,
    height: 150,
    marginBottom: spacing('xl'),
  },
  title: {
    marginBottom: spacing('xs'),
    textAlign: 'center',
  },
  subtitle: {
    color: getColor('text.secondary'),
    marginBottom: spacing('xl'),
    textAlign: 'center',
  },
  form: {
    width: '100%',
    maxWidth: 400,
  },
  input: {
    backgroundColor: getColor('background.paper'),
    paddingHorizontal: spacing('md'),
    paddingVertical: spacing('md'),
    borderRadius: getBorderRadius('md'),
    borderWidth: 1,
    borderColor: getColor('divider'),
    marginBottom: spacing('md'),
    color: getColor('text.primary'),
  },
  button: {
    backgroundColor: getColor('primary.main'),
    paddingVertical: spacing('md'),
    borderRadius: getBorderRadius('md'),
    alignItems: 'center',
  },
  buttonDisabled: {
    opacity: 0.7,
  },
  buttonText: {
    color: getColor('background.default'),
  },
});

export default AdminLoginScreen;
